import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
import classNames from 'classnames'
import Isvg from 'react-inlinesvg'

import { Tooltip } from 'components/tooltip'

import styles from './virtual_keyboard.scss'

import BetaLabel from 'assets/images/beta-label.svg'
import PrevArrow from 'assets/components/virtual_keyboard/prev-arrow.svg'
import NextArrow from 'assets/components/virtual_keyboard/next-arrow.svg'

class VirtualKeyboard extends PureComponent {

	constructor() {
		super()
		this.state = {
			category: 0,
		}
		this.previousCategory = this.previousCategory.bind(this)
		this.nextCategory = this.nextCategory.bind(this)
	}

	nextCategory() {
		this.setState({
			category: this.state.category===this.props.provider.length-1
				? 0
				: this.state.category + 1,
		})
	}

	previousCategory() {
		this.setState({
			category:
				this.state.category===0
					?this.props.provider.length-1
					:this.state.category-1,
		})
	}

	render() {
		return (
			<div onClick={this.props.onContainerClick} styleName='wrapper'>
				<div styleName='header'>
					<button styleName='header-prev' onClick={this.previousCategory}>
						<Isvg src={PrevArrow} cacheGetRequests={true}/>
					</button>
					<p styleName='header-title'>
						<span styleName='header-title-text'>
							{this.props.provider[this.state.category].category}
							<Isvg src={BetaLabel} cacheGetRequests={true} styleName='header-title-label' />
						</span>
					</p>
					<button styleName='header-next' onClick={this.nextCategory}>
						<Isvg src={NextArrow} cacheGetRequests={true}/>
					</button>
				</div>
				<ul styleName='list'>
					{
						this.props.provider[this.state.category].
							symbols.map((symbol, index) => (
								<li
									key={index}
									styleName={classNames({
										'list-item': true,
										'one-col': symbol.columns === 1,
										'two-col': symbol.columns === 2,
									})}>
									{symbol.tooltip &&
										<div styleName='list-item-tooltip'>
											<Tooltip arrow='top-left'>{symbol.tooltip}</Tooltip>
										</div>
									}
									<button
										styleName={classNames({
											'list-item-button': true,
											'list-item-button--active': symbol.mode===this.props.mode,
										})}
										onClick={() => {
											this.props.mathSymbolChange(symbol)
										}}
									>
										{symbol.value}
									</button>
								</li>
							))
					}
				</ul>
			</div>
		)
	}

}

VirtualKeyboard.propTypes = {
	mode: PropTypes.string,
	provider: PropTypes.array,
	mathSymbolChange: PropTypes.func,
	onContainerClick: PropTypes.func,
}

export default CSSModules(VirtualKeyboard, styles, {allowMultiple: true})
